import ModuleBuilder from './builders/ModuleBuilder'
import UrlBuilder from '../dependencies/urlBuilder'

let quote = ModuleBuilder.Rest('quotations')

quote
  .addState({ quote: 0 })
  .addGetters({ quote: ({ quote }) => quote })
  .addActions({
    async calculate(context) {
      const { length, width, from, to, resident = false, electricity = true, annual = false } = context.state.item
      const builder = new UrlBuilder()
        .set('from', from)
        .set('to', to)
        .set('width', width)
        .set('length', length)
        .set('resident', resident ? 1 : 0)
        .set('electricity', electricity ? 1 : 0)
        .set('annual', annual ? 1 : 0)
        .get()
      await quote.restRequest(context, 'QUOTE', { url: `/api/quotation${builder}` })
    }
  })
  .addMutations({
    'QUOTE': (state, { data }) => (state.quote = Number(data.data.total || 0).toFixed(2))
  })

export default quote
